import React from "react";
import style from "./Products.module.css";
import FeaturedProducts from "../FeaturedProducts/FeaturedProducts";

export default function Products() {
  return (
    <>
      <FeaturedProducts />
    </>
  );
}
